/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Box,
  CardHeader,
  Collapse,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ModuleConfig } from '@schamburg-web/interfaces';
import { DisplayCard } from '@schamburg-web/lakecounty';
import { useEffect, useState } from 'react';
import { getLocationDescription, getNormalizedIcon } from '../utils';
import SingleSnapshotView from './SingleSnapshotView';

const CameraCard: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <Box
      sx={{
        height: matches ? 'auto' : 'calc(100% - 150px)',
        borderRadius: 20,
        '& .MuiPaper-root': { background: 'inherit' },
      }}
    >
      {children}
    </Box>
  );
};

const CameraPopupCard: React.FC<{
  icon: any;
  module: ModuleConfig;
  onCollapseClose: () => void;
}> = ({ icon, module, onCollapseClose }) => {
  const [snapTs, setSnapTs] = useState(new Date().getTime());
  const [expandedIdx, setExpandedIdx] = useState<number | null>(1);
  const normalizedIcon = getNormalizedIcon(icon);

  // Update snapTs every 5 minutes (300,000 milliseconds)
  useEffect(() => {
    const interval = setInterval(() => {
      setSnapTs(new Date().getTime());
    }, 300000); // 5 minutes

    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ textAlign: 'center', maxWidth: 'auto' }}>
      {expandedIdx !== null && (
        <SingleSnapshotView
          approaches={normalizedIcon.approaches.approach}
          snapTs={snapTs}
          selectedIndex={expandedIdx}
          onClose={undefined}
          setExpandedIdx={setExpandedIdx}
          size="sidebar"
        />
      )}
    </Box>
  );
};

export const CameraSideBarCard: React.FC<{
  icon: any;
  module: ModuleConfig;
}> = ({ icon, module }) => {
  const [expanded, setExpanded] = useState(false);
  const normalizedIcon = getNormalizedIcon(icon);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <DisplayCard icon={icon} module={module}>
      <CardHeader
        title={
          <Box textAlign={'left'} marginLeft={matches ? '10px' : '0'}>
            <Typography variant="h6" sx={{ fontWeight: '300' }}>
              {getLocationDescription(normalizedIcon)}
            </Typography>
          </Box>
        }
        sx={{
          padding: '5px',
          maxWidth: '100%',
        }}
        onClick={handleExpandClick}
      />
      <Collapse
        in={expanded}
        timeout="auto"
        unmountOnExit
        sx={{
          maxHeight: 300,
          overflow: 'hidden',
          maxWidth: 350,
        }}
      >
        <CameraPopupCard
          icon={icon}
          module={module}
          onCollapseClose={() => handleExpandClick}
        ></CameraPopupCard>
      </Collapse>
    </DisplayCard>
  );
};

export default CameraSideBarCard;
